// extracted by mini-css-extract-plugin
export default {"f":"_35c3a38331","main":"_53c500f19d","btn":"_95c45b1cca","w":"_008083b029","h":"_1ea102f3c3","lh25":"_453311effd","wb":"bfc0acdc8f","b":"_4e873575ab","bx":"_17a9abb7df"};